import { type FiltersAssistantResponse } from 'javascripts/api';

export interface UserMessage {
  role: 'user';
  text: string;
}

export interface AssistantMessage {
  role: 'assistant';
  text: string;
  meta: FiltersAssistantResponse['text'];
}

export type Message = UserMessage | AssistantMessage;

export function responseToMessage(
  data: FiltersAssistantResponse
): AssistantMessage {
  return { role: 'assistant', text: data.text.raw, meta: data.text };
}

export function veryLikelyAKeyword(query: string) {
  if (query.length < 7) return true;

  const words = query.split(' ').filter(x => x.trim());
  return words.length < 2;
}
